import FormattedMessage from 'I18n/components/FormattedMessage';
import { EERIE } from 'HubStyleTokens/colors';
import UIIllustration from 'UIComponents/image/UIIllustration';
import StyledZeroState from './StyledZeroState';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const eerieStyle = {
  color: EERIE
};
const SearchNoThreadFocused = () => {
  return /*#__PURE__*/_jsxs(StyledZeroState, {
    children: [/*#__PURE__*/_jsx(UIIllustration, {
      name: "no-conversations",
      width: "200px"
    }), /*#__PURE__*/_jsx("h2", {
      style: eerieStyle,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.thread-search-and-filtering.zero-states.selectResults"
      })
    })]
  });
};
SearchNoThreadFocused.displayName = 'NoFocusedThread';
export default SearchNoThreadFocused;